
import superagent from "superagent";

const getUsersForWlf = (wlf_id) => {

  return new Promise((resolve, reject) => {
    superagent.agent()
      .get("/api/users/wlf")
      .query({ id: wlf_id})
      .then(res => {
        resolve(res.body.data);
      })
  });
};

const loadCSS = css_id => {

  return new Promise((resolve, reject) => {
    superagent.agent()
      .get("/api/whitelabel/getCSS")
      .query({css_id: css_id})
      .then(res => {
        resolve(res.body.data);
      });
  });
}

export { getUsersForWlf, loadCSS };
